module.exports = __webpack_public_path__ + "NeueFrutigerWorld-XtraBlk.469470df39a7b42990dd.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/assets/fonts/neue-frutiger-world/NeueFrutigerWorld-XtraBlk.ttf
// module id = ../../../../../src/assets/fonts/neue-frutiger-world/NeueFrutigerWorld-XtraBlk.ttf
// module chunks = styles